import axios from "axios";
import { SERVER_URL } from "../config";
import { Authorization } from "./authorization";

export const downloadCertificate = async (videoId: string) => {

  const url = SERVER_URL + "/pdf/generateCertificate/";

  var res = await axios.post(url, { videoId }, {
    headers: {
      Authorization: await Authorization.AuthToken()
    }
  });

  if (res && res.data) {
    var link = document.createElement("a");
    link.download = 'certificate';
    link.target = "_blank";
    link.href = res.data;
    document.body.appendChild(link);
    
    setTimeout(function () {
      link.click();
      document.body.removeChild(link);
    }, 500);
  }
}